import React, { ComponentType, useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '@/App/hooks';
import { getPrivacyPolicyThunk } from '@/features/i18n/i18nSlice';
import { selectLocale } from '@/features/i18n/selectLocale';
import { selectResources } from '@/features/i18n/selectResources';

export interface WithPrivacyPolicyTextProps {
  text: string;
}

export const withPrivacyPolicyText = <T extends object>(
  WrappedComponent: ComponentType<T & WithPrivacyPolicyTextProps>,
) => {
  const HOC = (props: T) => {
    const dispatch = useAppDispatch();
    const locale = useAppSelector(selectLocale);
    const resources = useAppSelector(selectResources);
    const { privacyPolicy } = resources;

    useEffect(() => {
      if (locale && (!privacyPolicy.initialized || privacyPolicy.locale !== locale)) {
        dispatch(getPrivacyPolicyThunk(locale));
      }
    }, [dispatch, privacyPolicy, locale]);

    if (!privacyPolicy.initialized || !locale) {
      return null;
    }

    return <WrappedComponent text={privacyPolicy.text} {...props} />;
  };
  HOC.displayName = `withPrivacyPolicyText(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  return HOC;
};
